import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Blog from "../components/Blog";

const BlogPage = () => {
  return (
    <div>
      <Header />
      <section className="hero-section-about d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 hero-content text-center">
              <span className="portfolio-hero-subtitle">Blog</span>

              <div className="hedding process-underline-flex justify-content-center">
                <div className="process-underline"></div>
                <div className="process-underline"></div>
              </div>

              <p className="about-title mb-0 px-0 py-0">
              At Hope Websolution, we go beyond services—we share knowledge, trends, and strategies that empower <br/> businesses in the digital space. Our blog features expert articles, practical tips, and industry updates <br/> to keep you ahead of the curve.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Blog showPagination={true} /> 
      <Footer />
    </div>
  );
};

export default BlogPage;
